<template>
  <div align="center" v-show="page_available === 1">
    <b-navbar-brand href="/">
      <img
          alt="Medicina.ru"
          height="98"
          src="../assets/med_logo.png"
      >
    </b-navbar-brand>
    <b-card
        class="mb-auto"
        style="max-width: 32rem; text-align: center"
        tag="article"
        title="Реферальная программа"
    >
      <b-card-text class="text-center" v-html="landingtitle"></b-card-text>

      <b-card-text class="text-left">
        {{ parent_fio }}
      </b-card-text>

      <b-card-text class="text-left" v-html="editorlandingtextData"></b-card-text>
      <b-card-text class="text-center">
        <Registration/>
      </b-card-text>
    </b-card>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import Registration from '@/components/Registration.vue'

export default {
  name: 'LandingPage',
  props: {},
  data() {
    return {
      error: '',
      referral_hash: null,
      landingtitle: '',
      editorlandingtextData: '',
      editorafterregisterData: '',
      parent_fio: '',
      page_available: false
    }
  },
  computed: {
    ...mapGetters(
        [
          'PARENT_PERSON', 'SETTINGS'
        ]),
  },
  created() {
  },
  mounted() {
    if (!!this.$route.params.referral_hash && this.$route.params.referral_hash.length == 32) {
      this.referral_hash = this.$route.params.referral_hash;
      this.getReferralData()
      this.getSettings()
    } else {
      this.throw404();
    }

  },
  components: {
    Registration
  },
  methods: {
    getReferralData() {
      this.parent_fio = '';
      if (!!this.referral_hash && this.referral_hash.length == 32) {
        this.$store
            .dispatch('getParentPerson', {referral_hash: this.referral_hash})
            .then(() => {
              this.parent_fio = this.PARENT_PERSON.parent_fio;
              if (this.parent_fio.length > 0) {
                this.page_available = 1;
              } else {
                this.throw404();
              }
            })
            .catch(err => {
              console.log(err)
              this.throw404();
            })
      }
    },
    getSettings() {
      this.$store
          .dispatch('getSettings')
          .then(() => {
            this.landingtitle = this.SETTINGS.landingtitle
            this.editorlandingtextData = this.SETTINGS.landingtext
            this.editorafterregisterData = this.SETTINGS.afterregister
          })
          .catch(err => {
            console.log(err)
          })
    },
    throw404() {
      this.$router.push({name: 'error404'}).catch(err => {
        console.log(err)
      })
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
